(function () {
  var enhancing = false;
  var queued = false;

  function setLoading(loading) {
    if (!document.documentElement || !document.documentElement.classList) return;
    document.documentElement.classList.toggle('berg-cart-loading', Boolean(loading));
  }

  function updateContinueShoppingLink() {
    document.querySelectorAll('a[href="/collections/all"]').forEach(function (link) {
      if (/continue shopping/i.test(link.textContent || '')) link.href = '/';
    });
  }

  function hasPendingArsenalRows() {
    return Array.prototype.some.call(document.querySelectorAll ? document.querySelectorAll('.cart-item') : [], function (row) {
      if (row.dataset && row.dataset.bergEnhanced) return false;
      return /(?:Elite|Raw|Legacy) Arsenal|Arsenal Bat Configuration/i.test(row.textContent || '');
    });
  }

  setLoading(true);

  function text(value) {
    return value == null ? '' : String(value);
  }

  function escapeHtml(value) {
    return text(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function componentOf(item) {
    var properties = (item && item.properties) || {};
    if (properties._berg_arsenal_component) return properties._berg_arsenal_component;
    if (properties._berg_arsenal_package === 'true') return 'package';
    if (properties._berg_config && properties._berg_arsenal_slot) return 'config';
    return '';
  }

  function isConfig(item) {
    return componentOf(item) === 'config';
  }

  function normalized(value) {
    return text(value).trim().toLowerCase();
  }

  function savedConfig(item) {
    try {
      return JSON.parse(text(((item && item.properties) || {})._berg_config) || '{}');
    } catch {
      return {};
    }
  }

  function packedConfigs(packageLine) {
    var properties = (packageLine && packageLine.properties) || {};
    var expected = Number(properties._berg_arsenal_size || text(properties['Arsenal Size']).match(/\d+/) || 0);
    var configs = [];
    for (var slot = 1; slot <= expected; slot += 1) {
      var raw = properties['_berg_arsenal_bat_' + slot];
      if (!raw) continue;
      try {
        var parsed = JSON.parse(text(raw));
        if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) continue;
        parsed._berg_arsenal_id = properties._berg_arsenal_id;
        parsed._berg_arsenal_series = properties._berg_arsenal_series;
        parsed._berg_arsenal_size = String(expected);
        parsed._berg_arsenal_slot = String(slot);
        parsed._berg_arsenal_rush = properties._berg_arsenal_rush || 'false';
        parsed._berg_arsenal_component = 'config';
        configs.push({ key: packageLine.key + ':bat:' + slot, quantity: 1, properties: parsed });
      } catch (error) {}
    }
    return configs;
  }

  function groupHealth(group) {
    var packageLine = (group || []).find(function (item) { return componentOf(item) === 'package'; });
    if (!packageLine) return { complete: false, configs: [], message: 'This Arsenal is missing its package line.' };
    var packageProperties = packageLine.properties || {};
    var expected = Number(packageProperties._berg_arsenal_size || text(packageProperties['Arsenal Size']).match(/\d+/) || 0);
    var configs = packedConfigs(packageLine);
    if (!configs.length) configs = (group || []).filter(isConfig);
    var slots = {};
    var complete = (expected === 3 || expected === 6) && configs.length === expected;
    configs.forEach(function (config) {
      var slot = Number((config.properties || {})._berg_arsenal_slot);
      if (!Number.isInteger(slot) || slot < 1 || slot > expected || slots[slot]) complete = false;
      slots[slot] = config;
      if (Number(config.quantity || 0) !== 1) complete = false;
    });
    for (var slot = 1; slot <= expected; slot += 1) if (!slots[slot]) complete = false;

    var paidAddons = (group || []).filter(function (item) {
      if (componentOf(item) !== 'addon' && componentOf(item) !== 'bodyguard') return false;
      var properties = item.properties || {};
      return Boolean(properties['Knob Decal'] || properties['Add-on']);
    });
    var consumed = [];
    configs.forEach(function (config) {
      var properties = config.properties || {};
      var configSlot = text(properties._berg_arsenal_slot);
      var expectedOptions = [];
      var knob = text(properties.Knob).trim();
      if (knob && normalized(knob) !== 'berg black') expectedOptions.push({ property: 'Knob Decal', value: knob });
      if (normalized(properties['Bodyguard Sleeve']) === 'added' || savedConfig(config).sleeve === true) {
        expectedOptions.push({ property: 'Add-on', value: 'Bodyguard Sleeve' });
      }
      expectedOptions.forEach(function (option) {
        var matches = paidAddons.filter(function (addon) {
          var addonProperties = addon.properties || {};
          return text(addonProperties._berg_arsenal_slot) === configSlot
            && normalized(addonProperties[option.property]) === normalized(option.value)
            && consumed.indexOf(addon) < 0;
        });
        if (matches.length !== 1 || Number((matches[0] || {}).quantity || 0) !== 1) complete = false;
        if (matches[0]) consumed.push(matches[0]);
      });
    });
    var expectedBodyguards = Number(packageProperties._berg_arsenal_bodyguards || 0);
    var bodyguardLines = paidAddons.filter(function (item) { return componentOf(item) === 'bodyguard'; });
    if (!Number.isInteger(expectedBodyguards) || expectedBodyguards < 0 || expectedBodyguards > 3) complete = false;
    if (expectedBodyguards === 0 && bodyguardLines.length) complete = false;
    if (expectedBodyguards > 0) {
      if (bodyguardLines.length !== 1) complete = false;
      var bodyguardLine = bodyguardLines[0];
      if (!bodyguardLine || normalized((bodyguardLine.properties || {})['Add-on']) !== 'bodyguard sleeve' || Number(bodyguardLine.quantity || 0) !== expectedBodyguards) complete = false;
      if (bodyguardLine) consumed.push(bodyguardLine);
    }
    if (consumed.length !== paidAddons.length) complete = false;

    var rushLines = (group || []).filter(function (item) { return componentOf(item) === 'rush'; });
    var expectsRush = packageProperties._berg_arsenal_rush === 'true';
    if ((expectsRush && rushLines.length !== 1) || (!expectsRush && rushLines.length !== 0)) complete = false;
    if (rushLines.some(function (item) { return Number(item.quantity || 0) !== 1; })) complete = false;

    return {
      complete: complete,
      configs: configs,
      paidAddons: paidAddons,
      rushIncluded: rushLines.length === 1,
      message: complete ? '' : 'This Arsenal is missing a required bat or paid option. Remove it and rebuild before checkout.'
    };
  }

  function paidOptionsLabel(health) {
    var addons = (health && health.paidAddons) || [];
    var knobCount = addons.filter(function (item) { return Boolean((item.properties || {})['Knob Decal']); }).length;
    var sleeveCount = addons.filter(function (item) { return normalized((item.properties || {})['Add-on']) === 'bodyguard sleeve'; }).reduce(function (count, item) { return count + Number(item.quantity || 0); }, 0);
    var options = [];
    if (knobCount) options.push(knobCount + ' Custom Knob Decal' + (knobCount === 1 ? '' : 's'));
    if (sleeveCount) options.push(sleeveCount + ' Bodyguard Sleeve' + (sleeveCount === 1 ? '' : 's'));
    if (health && health.rushIncluded) options.push('Rush Processing');
    return options.length ? 'Paid options: ' + options.join(' · ') : '';
  }

  function formatMoney(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function arsenalRank(item) {
    var properties = item.properties || {};
    var component = componentOf(item);
    if (component === 'package') return 0;
    if (component === 'bodyguard') return 97;
    if (component === 'rush') return 98;
    var slot = Number(properties._berg_arsenal_slot || 0);
    if (slot > 0) return slot * 10 + (component === 'config' ? 0 : 1);
    return 99;
  }

  function groupCartItems(items) {
    var groups = {};
    items.forEach(function (item) {
      var id = (item.properties || {})._berg_arsenal_id;
      if (!id) return;
      (groups[id] = groups[id] || []).push(item);
    });
    Object.keys(groups).forEach(function (id) {
      groups[id].sort(function (a, b) { return arsenalRank(a) - arsenalRank(b); });
    });
    return groups;
  }

  function updateCartCount(cart) {
    var count = 0;
    var arsenals = {};
    cart.items.forEach(function (item) {
      var id = (item.properties || {})._berg_arsenal_id;
      if (id) {
        if (!arsenals[id]) {
          arsenals[id] = true;
          count += 1;
        }
        return;
      }
      count += Number(item.quantity || 0);
    });
    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
      var spans = bubble.querySelectorAll('span');
      var visibleCount = String(count);
      var accessibleCount = count + (count === 1 ? ' item' : ' items');
      if (spans[0] && spans[0].textContent !== visibleCount) spans[0].textContent = visibleCount;
      if (spans[1] && spans[1].textContent !== accessibleCount) spans[1].textContent = accessibleCount;
      bubble.classList.toggle('hidden', count === 0);
    });
  }

  function reorderGroups(entries) {
    var groups = {};
    entries.forEach(function (entry) {
      var id = (entry.item.properties || {})._berg_arsenal_id;
      if (!id) return;
      (groups[id] = groups[id] || []).push(entry);
    });
    Object.keys(groups).forEach(function (id) {
      var group = groups[id];
      if (group.length < 2) return;
      var ordered = group.slice().sort(function (a, b) { return arsenalRank(a.item) - arsenalRank(b.item); });
      var alreadyOrdered = ordered.every(function (entry, index) { return entry.row === group[index].row; });
      if (alreadyOrdered) return;
      var parent = group[0].row.parentNode;
      var marker = document.createComment('berg-arsenal-order');
      parent.insertBefore(marker, group[0].row);
      ordered.forEach(function (entry) {
        parent.insertBefore(entry.row, marker);
      });
      parent.removeChild(marker);
    });
  }

  function addSpec(parts, label, value) {
    if (value) parts.push('<span class="berg-cart__spec">' + escapeHtml(label) + ' ' + escapeHtml(value) + '</span>');
  }

  function enhanceConfig(entry) {
    var row = entry.row;
    if (row.dataset.bergEnhanced === 'config') return;
    var item = entry.item;
    var properties = item.properties || {};
    var slot = properties._berg_arsenal_slot || text(properties['Arsenal Bat']).split(' ')[0] || '';
    var size = properties._berg_arsenal_size || text(properties['Arsenal Bat']).split(' ').pop() || '';
    var title = row.querySelector('.cart-item__name');
    var details = row.querySelector('.cart-item__details');
    var dl = details && details.querySelector('dl');
    var visiblePrice = details && details.querySelector(':scope > .product-option');
    var totals = row.querySelectorAll('.cart-item__totals .price');
    var specs = [];
    addSpec(specs, 'Model', properties.Model);
    addSpec(specs, 'Length', properties.Length);
    addSpec(specs, 'Wood', properties.Wood);
    addSpec(specs, 'Weight', properties.Weight);
    addSpec(specs, '', properties['Swing Feel']);
    if (properties.Cup) addSpec(specs, '', properties.Cup === 'To Weight' ? 'Cupped to weight' : properties.Cup);
    row.classList.add('berg-cart-item--arsenal', 'berg-cart-item--arsenal-member', 'berg-cart-item--arsenal-config');
    if (details) {
      var series = properties._berg_arsenal_series || '';
      var finishSpecs = [];
      details.insertAdjacentHTML('afterbegin', '<div class="berg-cart__eyebrow">Bat ' + escapeHtml(slot) + ' of ' + escapeHtml(size) + '</div>');
      if (title) title.textContent = properties.Model || 'Custom bat';
      if (dl) dl.outerHTML = '<div class="berg-cart__specs berg-cart__specs--core">' + specs.join('') + '</div>';
      if (series === 'elite') {
        addSpec(finishSpecs, '', 'Elite Series · Black high gloss + metallic gold');
      } else {
        addSpec(finishSpecs, 'Handle', [properties['Handle Color'], properties['Handle Finish']].filter(Boolean).join(' · '));
        addSpec(finishSpecs, 'Barrel', [properties['Barrel Color'], properties['Barrel Finish']].filter(Boolean).join(' · '));
        addSpec(finishSpecs, 'Trademark', properties.Trademark);
        addSpec(finishSpecs, 'Engraving', properties.Engraving && properties.Engraving !== 'None' ? properties.Engraving : '');
      }
      addSpec(finishSpecs, 'Knob', properties.Knob);
      details.insertAdjacentHTML('beforeend', '<div class="berg-cart__specs berg-cart__specs--finish">' + finishSpecs.join('') + '</div>');
      if (visiblePrice) visiblePrice.innerHTML = '<span class="berg-cart__included">Included in Arsenal</span>';
    }
    totals.forEach(function (price) { price.innerHTML = '<span class="berg-cart__included">Included</span>'; });
    row.dataset.bergEnhanced = 'config';
  }

  function hideArsenalMember(entry) {
    entry.row.classList.add('berg-cart-item--arsenal', 'berg-cart-item--arsenal-member');
    entry.row.dataset.bergEnhanced = componentOf(entry.item) || 'member';
  }

  function removeArsenal(groupId, button) {
    if (!groupId || button.disabled) return;
    button.disabled = true;
    button.textContent = 'Removing…';
    fetch('/cart.js', { headers: { accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var updates = {};
        cart.items.forEach(function (item) {
          if ((item.properties || {})._berg_arsenal_id === groupId) updates[item.key] = 0;
        });
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'content-type': 'application/json', accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function (response) { if (!response.ok) throw new Error('remove'); window.location.reload(); })
      .catch(function () { button.disabled = false; button.textContent = 'Remove Arsenal'; });
  }

  function batSummary(item) {
    var properties = Object.assign({}, item.properties || {});
    if (savedConfig(item).sleeve === true && !properties['Bodyguard Sleeve']) properties['Bodyguard Sleeve'] = 'Added';
    var coreFields = [
      ['Swing Feel', 'Swing feel'],
      ['Length', 'Length'],
      ['Wood', 'Wood'],
      ['Weight', 'Weight']
    ];
    var designFields = [
      ['Cup', 'Cup'],
      ['Handle Color', 'Handle color'],
      ['Handle Finish', 'Handle finish'],
      ['Barrel Color', 'Barrel color'],
      ['Barrel Finish', 'Barrel finish'],
      ['Trademark', 'Trademark'],
      ['Stripe', 'Stripe'],
      ['Engraving', 'Engraving'],
      ['Knob', 'Knob'],
      ['Bodyguard Sleeve', 'Bodyguard Sleeve']
    ];
    function renderFields(fields) {
      return fields.map(function (field) {
        var value = properties[field[0]];
        if (!value || value === 'None' || value === 'Not added') return '';
        if (field[0] === 'Cup' && value === 'To Weight') value = 'Cupped to weight';
        return '<span class="berg-cart__arsenal-bat-spec"><span>' + escapeHtml(field[1]) + '</span><strong>' + escapeHtml(value) + '</strong></span>';
      }).filter(Boolean).join('');
    }
    var coreSpecs = renderFields(coreFields);
    var designSpecs = renderFields(designFields);
    var series = properties._berg_arsenal_series || '';
    var designDetails = series !== 'elite' && designSpecs
      ? '<details class="berg-cart__arsenal-design"><summary>View design details</summary><div class="berg-cart__arsenal-design-specs">' + designSpecs + '</div></details>'
      : '';
    return '<div class="berg-cart__arsenal-bat">' +
      '<div class="berg-cart__arsenal-bat-heading"><span class="berg-cart__arsenal-bat-number">Bat ' + escapeHtml(properties._berg_arsenal_slot || '') + '</span>' +
      '<strong>' + escapeHtml(properties.Model || 'Custom bat') + '</strong></div>' +
      '<div class="berg-cart__arsenal-bat-specs">' + coreSpecs + '</div>' +
      designDetails +
      '</div>';
  }

  function setCheckoutState(incomplete) {
    document.querySelectorAll('button[name="checkout"], #CartDrawer-Checkout').forEach(function (button) {
      if (incomplete) {
        if (!button.disabled) button.dataset.bergArsenalDisabled = 'true';
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      } else if (button.dataset.bergArsenalDisabled === 'true') {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        delete button.dataset.bergArsenalDisabled;
      }
    });
  }

  function enhancePackage(entry, group) {
    var row = entry.row;
    var item = entry.item;
    var properties = item.properties || {};
    var details = row.querySelector('.cart-item__details');
    var title = row.querySelector('.cart-item__name');
    var dl = details && details.querySelector('dl');
    row.classList.add('berg-cart-item--arsenal', 'berg-cart-item--arsenal-package');
    if (details && row.dataset.bergEnhanced !== 'package') {
      details.insertAdjacentHTML('afterbegin', '<div class="berg-cart__eyebrow">Arsenal</div>');
      if (title) title.textContent = properties.Arsenal || item.product_title || 'Arsenal';
      if (dl) dl.outerHTML = '<div class="berg-cart__specs"><span class="berg-cart__spec">' + escapeHtml(properties['Arsenal Size'] || '') + '</span></div>';
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'berg-cart__remove-arsenal';
      button.textContent = 'Remove Arsenal';
      button.addEventListener('click', function () { removeArsenal(properties._berg_arsenal_id, button); });
      details.appendChild(button);
    }
    if (details) {
      var health = groupHealth(group || []);
      var configs = health.configs;
      var groupTotal = (group || []).reduce(function (total, groupItem) {
        return total + Number(groupItem.final_line_price == null ? groupItem.line_price : groupItem.final_line_price || 0);
      }, 0);
      if (groupTotal > 0) {
        row.querySelectorAll('.cart-item__totals .price').forEach(function (price) { price.textContent = formatMoney(groupTotal); });
      }
      var expected = Number(properties._berg_arsenal_size || text(properties['Arsenal Size']).match(/\d+/) || 0);
      var signature = expected + ':' + health.complete + ':' + (group || []).map(function (groupItem) { return groupItem.key + ':' + groupItem.quantity; }).join('|');
      if (details.dataset.bergArsenalSummary === signature) {
        row.dataset.bergEnhanced = 'package';
        return;
      }
      var oldSummary = details.querySelector('.berg-cart__arsenal-bats');
      var oldWarning = details.querySelector('.berg-cart__arsenal-warning');
      var oldTreatment = details.querySelector('.berg-cart__arsenal-treatment');
      var oldOptions = details.querySelector('.berg-cart__arsenal-options');
      if (oldSummary) oldSummary.remove();
      if (oldWarning) oldWarning.remove();
      if (oldTreatment) oldTreatment.remove();
      if (oldOptions) oldOptions.remove();
      var removeButton = details.querySelector('.berg-cart__remove-arsenal');
      var summary = document.createElement('div');
      summary.className = 'berg-cart__arsenal-bats';
      summary.innerHTML = configs.map(batSummary).join('');
      details.insertBefore(summary, removeButton || null);
      if ((properties._berg_arsenal_series || '').toLowerCase() === 'elite') {
        var treatment = document.createElement('p');
        treatment.className = 'berg-cart__arsenal-treatment';
        treatment.textContent = 'All bats: black high gloss, metallic gold trim, cupped to weight, Berg Black knob.';
        details.insertBefore(treatment, removeButton || null);
      }
      var optionsLabel = paidOptionsLabel(health);
      if (optionsLabel) {
        var paidOptions = document.createElement('p');
        paidOptions.className = 'berg-cart__arsenal-options';
        paidOptions.textContent = optionsLabel;
        details.insertBefore(paidOptions, removeButton || null);
      }
      if (!health.complete) {
        var warning = document.createElement('p');
        warning.className = 'berg-cart__arsenal-warning';
        warning.textContent = health.message;
        details.insertBefore(warning, removeButton || null);
      }
      details.dataset.bergArsenalSummary = signature;
    }
    row.dataset.bergEnhanced = 'package';
  }

  function enhance() {
    if (enhancing) return;
    enhancing = true;
    updateContinueShoppingLink();
    fetch('/cart.js', { headers: { accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        updateCartCount(cart);
        var groups = groupCartItems(cart.items);
        var incomplete = Object.keys(groups).some(function (id) {
          return !groupHealth(groups[id]).complete;
        });
        var rows = Array.prototype.slice.call(document.querySelectorAll('#main-cart-items .cart-item'));
        var entries = rows.map(function (row) {
          var match = row.id.match(/CartItem-(\d+)/);
          return { row: row, item: match ? cart.items[Number(match[1]) - 1] : null };
        }).filter(function (entry) { return entry.item; });
        reorderGroups(entries);
        entries.forEach(function (entry) {
          var properties = entry.item.properties || {};
          if (!properties._berg_arsenal_id) return;
          if (componentOf(entry.item) === 'package') enhancePackage(entry, groups[properties._berg_arsenal_id]);
          else if (isConfig(entry.item)) enhanceConfig(entry);
          else hideArsenalMember(entry);
        });
        var itemsByKey = {};
        cart.items.forEach(function (item) { itemsByKey[item.key] = item; });
        var drawerRows = Array.prototype.slice.call(document.querySelectorAll('cart-drawer .cart-item'));
        var drawerEntries = drawerRows.map(function (row, index) {
          var item = row.dataset.bergCartKey ? itemsByKey[row.dataset.bergCartKey] : cart.items[index];
          if (item) row.dataset.bergCartKey = item.key;
          return { row: row, item: item };
        }).filter(function (entry) { return entry.item; });
        reorderGroups(drawerEntries);
        drawerEntries.forEach(function (entry) {
          var properties = entry.item.properties || {};
          if (!properties._berg_arsenal_id) return;
          if (componentOf(entry.item) === 'package') enhancePackage(entry, groups[properties._berg_arsenal_id]);
          else if (isConfig(entry.item)) enhanceConfig(entry);
          else hideArsenalMember(entry);
        });
        setCheckoutState(incomplete);
      })
      .catch(function () {})
      .finally(function () {
        enhancing = false;
        setLoading(false);
      });
  }

  function queueEnhance() {
    if (queued) return;
    if (hasPendingArsenalRows()) setLoading(true);
    queued = true;
    setTimeout(function () { queued = false; enhance(); }, 120);
  }

  if (typeof window !== 'undefined' && window.__BERG_CART_TEST__) {
    window.__bergArsenalCartTest = { componentOf: componentOf, groupHealth: groupHealth, packedConfigs: packedConfigs, paidOptionsLabel: paidOptionsLabel };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance);
  else enhance();
  new MutationObserver(queueEnhance).observe(document.documentElement, { childList: true, subtree: true });
})();
